import { useExperience } from "../../../context/ExperienceContext";
import { getExperienceConfig } from "../../../config/experience.config";
import "./SectionHeading.css";

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "center",
  className = "",
  icon: CustomIcon,
  titleClassName = "",
  descriptionClassName = "",
}) {
  const { mode } = useExperience();
  const modeConfig = getExperienceConfig(mode);
  const Icon = CustomIcon || modeConfig.sectionIcon;

  return (
    <div className={`section-heading section-heading--${align} ${className}`.trim()}>
      {eyebrow && (
        <div className="section-heading__eyebrow">
          <span className="section-heading__line" />
          {Icon && <Icon className="section-heading__icon" />}
          <strong>{eyebrow}</strong>
          <span className="section-heading__line" />
        </div>
      )}

      {title && <h2 className={titleClassName}>{title}</h2>}
      {description && <p className={descriptionClassName}>{description}</p>}
    </div>
  );
}
